// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.UXu3f{display:flex;flex-direction:column;gap:8px}.UXu3f.T8xTe{gap:4px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"side": `UXu3f`,
	"mobile": `T8xTe`
};
export default ___CSS_LOADER_EXPORT___;
